const matchesReducer = (data = {}, action) => {
    switch(action.type){
        case 'ADD_MATCHES':
            return {
                ...data,
                ...action.data
            }
        default:
            return data;
    }
}

export default matchesReducer;